import React, { useRef, useState, useEffect } from 'react';

const paragraphs = [
  'India, México, Marruecos, Israel, Camboya, Argentina, Estados Unidos y Guatemala. Cada lugar tiene su propia historia, su propio ritmo y una manera particular de ordenar el tiempo, habitar el espacio y mirar al otro. Nada de eso es intercambiable. Sin embargo, de un país a otro, ciertas escenas parecían repetirse: alguien espera, alguien trabaja, alguien reza, alguien juega, alguien mira hacia un lugar que queda fuera de cuadro.',
  'Pero ninguna repetición es idéntica. La misma luz cae de otra manera. Un gesto conocido adquiere un significado nuevo. Aquello que parece regresar nunca vuelve exactamente igual.',
  'Fotografiar fue mi manera de detenerme frente a esa tensión: reconocer algo familiar en lo desconocido y, al mismo tiempo, descubrir lo extraño dentro de lo cotidiano. No para capturar los lugares ni explicar a las personas, sino para producir y reflejar ese encuentro.',
  'Para mí, la fotografía es una excusa para el encuentro, para conocer personas. Una fotografía parece afirmar: esto ocurrió una vez. Y cada vez que alguien la mira, vuelve a ocurrir. En otro tiempo, frente a otros ojos, con un sentido diferente.',
  'Una colección de instantes únicos que, al reunirse, comienzan a resonar entre sí. La diferencia permite también que haya algo común: nos separa y, a la vez, nos transforma y vuelve singular cada experiencia. La repetición crea ritmos, correspondencias y ecos.',
];

const Statement = () => {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const o = new IntersectionObserver(
      ([e]) => e.isIntersecting && (setVis(true), o.disconnect()),
      { rootMargin: '-8% 0px' }
    );
    if (ref.current) o.observe(ref.current);
    return () => o.disconnect();
  }, []);

  return (
    <section id="texto" className="border-t border-line py-24 md:py-36 px-6">
      <div
        ref={ref}
        className={`max-w-[720px] mx-auto text-center transition-all duration-1000 ${
          vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <p className="text-[11px] tracking-[0.42em] uppercase text-muted mb-8">Diferencia · Repetición</p>

        <div className="space-y-6 font-serif text-[17px] md:text-[19px] leading-relaxed text-ink/85 text-left md:text-center">
          <p>{paragraphs[0]}</p>

          <div
            className={`space-y-6 overflow-hidden transition-all duration-700 ease-out ${
              open ? 'max-h-[1600px] opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            {paragraphs.slice(1).map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            <p className="font-serif italic text-xl md:text-2xl text-ink !mt-10">Entre ambas sucede la vida.</p>
          </div>
        </div>

        {!open && (
          <button
            onClick={() => setOpen(true)}
            className="mt-9 text-[12px] tracking-[0.22em] uppercase text-muted hover:text-ink border-b border-line hover:border-ink pb-1 transition-colors"
          >
            Leer el texto completo
          </button>
        )}
      </div>
    </section>
  );
};

export default Statement;
